<template>
    <div style="width:90%">
        <div class="container_body">
            <header class="header_nav">
                <el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
                    <el-form-item label="模板标题" class='tiny'>
                        <el-input style="width: 200px;" v-model="searchInfo.emailTitle" placeholder="请输入模板标题"></el-input>
                    </el-form-item>
					<el-form-item label="邮件标题" class='tiny'>
					    <el-input style="width: 200px;" v-model="searchInfo.emailSubtitle" placeholder="请输入邮件标题"></el-input>
					</el-form-item>
              

              
                    <el-form-item style="width:40%">
                        <template>
                            <el-button type="primary" @click="search">查询</el-button>
                            <el-button @click="empty">清空</el-button>
                            <el-button type="primary" @click="editialogVisible('')">新增
                            </el-button>
                        </template>
                    </el-form-item>
                </el-form>
            </header>
        </div>


        <el-table :data="userActivityList.list" stripe style="width: 100%;" :header-cell-style="headClass"
            v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <el-table-column prop="id" label="序号" sortable align="center">
            </el-table-column>
			
            <el-table-column prop="emailTitle" label="模板标题" align="center" :formatter="changeNull"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="emailSubtitle" label="邮件标题" align="center" >
              
            </el-table-column>
            <el-table-column prop="emailContent" label="通知内容" align="center" :formatter="changeNull"
                :show-overflow-tooltip="true" width="100">
                <template slot-scope="scope">
                    <el-button size="small" type="text" @click="showContent(scope.row.emailContent)">查看</el-button>
                    <!-- <div v-html="scope.row.content"></div> -->
                </template>
            </el-table-column>




            <el-table-column prop="createTime" label="创建时间" align="center" width="200">
            </el-table-column>

        <!--    <el-table-column prop="isEnable" label="是否常用" align="center" width="100">
                <template slot-scope="scope">
                    <p v-if="!scope.row.isEnable">禁用</p>
                    <p v-else>启用</p>
                </template>
            </el-table-column> -->
            <el-table-column  label="操作"  fixed="right" align="center">
                　　　　<template slot-scope="scope">
                    <el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
                    　　　　　　<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
                    <!-- 　　　　　　<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">拨币</el-button> -->
                    　　　　
                </template>
                　　</el-table-column>
        </el-table>
        <el-pagination style="margin: 20px;" background :current-page="userActivityList.pageNum"
            @current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
            :total="userActivityList.total" @size-change="handleSizeChange">
        </el-pagination>

        <!-- 新增、编辑 -->
        <el-dialog style="float:rigin" :title="poupTitle" :visible.sync="editDialogVisible" width="600px" :close-on-click-modal="false">
            <div class="app-container">
                <el-form ref="form" :model="form" :rules="mainFormRules" size="medium">
                  
                    <el-form-item label="模板标题:" label-width="120px"> 
                            <el-input v-model="form.emailTitle" placeholder="请输入模板标题" style="width: 400px;" />
                    </el-form-item>

                    <el-form-item label="邮件标题:" label-width="120px">
                         <el-input v-model="form.emailSubtitle" placeholder="请输入邮件标题" style="width: 400px;" />
                    </el-form-item>
					
					
                    <el-form-item label="通知内容:" label-width="120px">
                        
                        <div id="lpc-quill" class="quill"  style="height:280px;">
                            <el-upload v-show="false" ref="upload" class="upload-demo" :action="httpUrl"
                                :before-upload="beforeUpload" :on-success="upScuccess" :on-error="uploadError" />
                            <quill-editor v-model="form.emailContent" ref="myQuillEditor" class="editer" style="height:200px;"
                                :options="editorOption" @ready="onEditorReady($event)">
                            </quill-editor>
                        </div>
                    </el-form-item>


                    <el-form-item>
                        <el-button @click="editDialogVisible = false">取 消</el-button>
                        <el-button :loading="editLoading" type="primary" @click="toEdit()">提交</el-button>
                        <!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

        <!-- 查看 -->
        <el-dialog title="提示" :visible.sync="showContentDialog" width="50%">
            <span v-html="contentValue"></span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="showContentDialog = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        uploadFileServer
    } from '@/api/axios.js'
    var urls = uploadFileServer('notily');
    import { quillEditor } from 'vue-quill-editor' //调用编辑器
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
	
    export default {
        components: {
            quillEditor
        },
        data() {
            return {
				notifyType:'',
				storeId:'',
                loading: false,
                userActivityList: [], //用户列表
                editDialogVisible: false,
                poupTitle: '',
                showUrl: false,
                editLoading: false,
                form: {
                    title: "",
                    titleEn: "",
                    action: "richtext",
                    content: "",
                    contentEn: "",
                    isEnable: true,
                    contentUrl: "",
					
                },
                mainFormRules: {
                    title: { required: true, message: "请输入标题", trigger: "blur" },
                },
                id: '',//id
                formLabelWidth: "150px",
                page: { pageNum: 1, pageSize: 10 },
                searchInfo: {
                    action: '',
                },
                showContentDialog: false,
                contentValue: "",
                httpUrl: urls,
				storelist:[],
               editorOption: {
               	// 富文本编辑器配置
               	placeholder: "请输入内容",
               	modules: {
               		toolbar: {
               			container: [
               				["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
               				[{
               						header: 1,
               					},
               					{
               						header: 2,
               					},
               				], // 标题，键值对的形式；1、2表示字体大小
               				[{
               						list: "ordered",
               					},
               					{
               						list: "bullet",
               					},
               				], // 列表
               				[{
               						script: "sub",
               					},
               					{
               						script: "super",
               					},
               				], // 上下标
               				[{
               						indent: "-1",
               					},
               					{
               						indent: "+1",
               					},
               				], // 缩进
               				[{
               					direction: "rtl",
               				}, ], // 文本方向
               				[{
               					size: ["small", false, "large", "huge"],
               				}, ], // 字体大小
               				[{
               						color: [],
               					},
               					{
               						background: [],
               					},
               				], // 字体颜色，字体背景颜色
               				[{
               					align: [],
               				}, ], // 对齐方式
               				["clean"], // 清除字体样式
               				["image"], // 上传图片、上传视频
               			],
               			handlers: {
               				image: function(value) {
               					console.log(value)
               					if (value) {
               						document
               							.querySelector("#lpc-quill .upload-demo input")
               							.click();
               					} else {
               						this.quill.format("image", false);
               					}
               				},
               			},
               
               		},
               	},
               	theme: "snow",
               }
            };
        },
        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill
            }
        },
        methods: {
            selectChange(value) {
                // console.log(value);
                if (value == 'url') {
                    this.showUrl = true
                } else {
                    this.showUrl = false
                }
                // this.form.action = event
            },
            empty() {
                this.searchInfo = {}
            },
            search() {
                this.page.pageNum = 1;
                this.getNotifyList()
            },
            showContent(content) {
                this.contentValue = content
                this.showContentDialog = true
            },
            //编辑弹框
            editialogVisible(id) {
                this.form = {}
				this.notifyType=''
                // this.form.action = 'richtext'
                this.form.isEnable = true
                if (id) {
                    //编辑
                    this.id = id
                    this.poupTitle = '编辑';
                    this.$api.findByIdTemplate(id).then((res) => {
                        if (res.state == 'success') {
                            this.form = res.data
							
                            
                            this.editDialogVisible = true;
                        }
                    })
                } else {
                    this.id = ""
                    this.poupTitle = '新增';
                    this.form = {}
                    this.form.action = 'richtext'
                    this.showUrl = false;
                    this.form.isEnable = true;
                    this.editDialogVisible = true;
                }

            },
            toEdit() {
				// console.log(this.form.content);
                this.editLoading = true;
                if (this.showUrl) {
                    this.form.content = this.form.contentUrl
                    this.form.contentEn = this.form.contentUrl
                }
                if (this.id) {
                    //编辑
                    let data = {
                        id: this.id,
                        ...this.form,
                       
						// notifyType:this.notifyType
                    }
                    this.$api.editTemplate(data).then((res) => {
                        if (res.state == 'success') {
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            this.editDialogVisible = false;
                            this.getNotifyList();
                        } else {
                            this.$message.error(res.message);
                        }
                        this.editLoading = false;
                    })
                } else {
                    //添加
                    let data = {
                       ...this.form,
                       
                    }
                    this.$api.addTemplate(data).then((res) => {
                        if (res.state == 'success') {
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            this.editDialogVisible = false;
                            this.getNotifyList();
                        } else {
                            this.$message.error(res.message);
                        }
                         this.editLoading = false;
                    })
                }
            },
            headClass() {
                return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
            },
            changeNull(row, column, cellValue) {
                if (cellValue) {
                    return cellValue;
                } else {
                    return "暂无";
                }
            },
            pageChange(data) {
                this.page.pageNum = data
                this.getNotifyList()
            },
            handleSizeChange(val) {
                this.page.pageSize = val
                this.getNotifyList()
            },
            getNotifyList() {
                this.loading = true
                let data = {
                    pageNum: this.page.pageNum,
                    pageSize: this.page.pageSize,
                    ...this.searchInfo,
                  
					// storeId:this.searchInfo.storeId
                }
                this.$api.findListemail(data).then((res) => { 
                    if (res.state == 'success') {
                        this.userActivityList = res.data
                        this.loading = false
                    }
                })
            },
            //删除
            toDelete(id) {
                this.$confirm('此操作将永久删除该模板, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.delTemplate(id).then((res) => {
                        if (res.state == 'success') {
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            this.getNotifyList();
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 8;
            if (!isLt2M) {
            	this.$message.error('上传图片大小不能超过 8MB!');
            	return false;
            }
            var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
            if (!imgStr.test(file.name)) {
            	this.$message.error("文件不是图片类型，请上传正确格式图片！");
            	return false;
            }
            return isLt2M, imgStr;
            },
            upScuccess(res, file) {
               const quill = this.$refs.myQuillEditor.quill;
               if (res.state == "success" && res.message !== null) {
               	const length = quill.getSelection().index; // 获取光标所在位置
               	quill.insertEmbed(length, "image", res.message); // 插入图片
               	quill.setSelection(length + 1); // 调整光标位置到最后
               } else {
               	this.$message.error("图片上传失败");
               }
            },
            uploadError() {
                this.$message.error('图片上传失败')
            },
            onEditorReady(editor) { // 准备编辑器
                // console.log(editor)
            },
            beforeUploaden(file) {
                const isLt2M = file.size / 1024 / 1024 < 8;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 8MB!');
                }
                return isLt2M;
            },
            upScuccessen(res, file) {
                const quill = this.$refs.myQuillEditoren.quill
                if (res.state === 'success' && res.data !== null) {
                    const length = quill.getSelection().index // 获取光标所在位置
                    quill.insertEmbed(length, 'image', res.data) // 插入图片
                    quill.setSelection(length + 1) // 调整光标位置到最后
                } else {
                    this.$message.error('图片上传失败')
                }
            },
            uploadErroren() {
                this.$message.error('图片上传失败')
            },
         
        },
        created() {
            this.getNotifyList();
			this.storeId=window.sessionStorage.getItem('storeId')
			
        },
        mounted: function () {
        },
    };
</script>

<style>

    .demo-table-expand {
        font-size: 0;
        margin-left: 30px;
    }

    .demo-table-expand label {
        width: 100px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;

        
    }
</style>